"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var React = require("react");
var Confirmation_1 = require("../../Confirmation");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var DialogContent_1 = require("@mui/material/DialogContent");
var FormGroup_1 = require("@mui/material/FormGroup");
var Typography_1 = require("@mui/material/Typography");
var DialogActions_1 = require("@mui/material/DialogActions");
var Button_1 = require("@mui/material/Button");
var Dialog_1 = require("@mui/material/Dialog");
var Tree_1 = require("../../../components/Tree");
var RenewPolicyAction = /** @class */ (function (_super) {
    __extends(RenewPolicyAction, _super);
    function RenewPolicyAction(props) {
        var _this = _super.call(this, props) || this;
        _this.renewPolicy = function () {
            _this.supportPortalService.setPerformRenewalFlag(_this.props.customerReferenceNumber, _this.props.policyNumber, true).subscribe(function () {
                var _a;
                // Trigger renewal after enabling renewal flag
                _this.supportPortalService
                    .renewPolicyFromSupportPortal(_this.props.customerReferenceNumber, _this.props.policyNumber)
                    .subscribe(function (response) {
                    if (!(response instanceof Error)) {
                        _this.setState({ showRenewalInitiatedPopup: true });
                    }
                });
                _this.supportPortalService.logAgentActivity(_this.props.customerReferenceNumber, { "action": "Renew a grace period renewal", "customer": _this.props.policyNumber, "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString() }).subscribe();
            });
            _this.setState({ showRenewNowConfirmation: false });
        };
        _this.doConfirmation = function () {
            _this.setState({ showRenewalInitiatedPopup: false });
        };
        _this.state = {
            showRenewNowConfirmation: false,
            showRenewalInitiatedPopup: false
        };
        return _this;
    }
    RenewPolicyAction.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService.logAgentActivity(this.props.customerReferenceNumber, { "action": "No Action", "customer": this.props.policyNumber }).subscribe(function (agentActivity) {
            _this.setState({ agentActivityId: agentActivity.id });
        });
    };
    RenewPolicyAction.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { className: "btn-text cursor-pointer text-decoration-none on-hover-underline", onClick: function () { return _this.setState({ showRenewNowConfirmation: true }); }, children: "Renew a grace period renewal" }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showRenewNowConfirmation, hide: function () { return _this.setState({ showRenewNowConfirmation: false }); }, confirm: function () { return _this.renewPolicy(); }, title: "", message: "Are you sure you want to renew the grace period policy?" }), (0, jsx_runtime_1.jsxs)(Dialog_1.default, { open: this.state.showRenewalInitiatedPopup, onClose: this.doConfirmation, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)(DialogContent_1.default, { className: "pb-0 text-center", children: (0, jsx_runtime_1.jsx)(FormGroup_1.default, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "subtitle1", children: "The policy's renewal has been initiated, we will try to take payment" }) }) }), (0, jsx_runtime_1.jsx)(DialogActions_1.default, { children: (0, jsx_runtime_1.jsx)(Button_1.default, { onClick: this.doConfirmation, color: "primary", children: "OK" }) })] })] }) }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], RenewPolicyAction.prototype, "supportPortalService", void 0);
    RenewPolicyAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR", "Support"),
        __metadata("design:paramtypes", [Object])
    ], RenewPolicyAction);
    return RenewPolicyAction;
}(React.Component));
exports.default = RenewPolicyAction;
//# sourceMappingURL=RenewPolicyAction.js.map